import { type InputHTMLAttributes } from 'react';
import { cx, inputClass } from './utils.js';

export type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  /** Skip the default top margin (e.g. inside a flex toolbar). */
  flush?: boolean;
};

export function TextInput({ className, flush = false, ...rest }: TextInputProps) {
  return (
    <input
      {...rest}
      className={cx(
        flush
          ? 'block h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none dark:border-slate-600 dark:bg-slate-950 dark:text-slate-100 dark:placeholder:text-slate-500'
          : inputClass,
        className,
      )}
      data-ui="text-input"
    />
  );
}
